import { Box, Grid, Text, useDisclosure, Flex } from '@chakra-ui/react'
import { AgentIcon } from '../components/agents/AgentIcon'
import { AgentDialog } from '../components/agents/AgentDialog'
import { AgentSidebar } from '../components/agents/AgentSidebar'
import { useAgentStore } from '../stores/agentStore'
import { useState } from 'react'

export const Agents = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isSidebarOpen, onToggle: onSidebarToggle } = useDisclosure({ defaultIsOpen: true })
  const agents = useAgentStore(state => state.agents)
  const [selectedAgentId, setSelectedAgentId] = useState<number | undefined>()

  const handleAgentClick = (id: number) => {
    setSelectedAgentId(id)
    onOpen()
  }

  const handleNewAgent = () => {
    setSelectedAgentId(undefined)
    onOpen()
  }

  return (
    <Flex>
      <Box flex="1" p={4}>
        <Text fontSize="2xl" mb={6}>Agents</Text>
        
        <Text fontSize="lg" mb={4}>Active Agents</Text>
        
        <Grid templateColumns="repeat(4, 1fr)" gap={6}>
          {agents.map(agent => (
            <AgentIcon 
              key={agent.id}
              name={agent.name}
              status={agent.status}
              paradigm={agent.paradigm}
              onClick={() => handleAgentClick(agent.id)}
            />
          ))}
        </Grid>

        <AgentDialog 
          isOpen={isOpen} 
          onClose={onClose}
          selectedAgentId={selectedAgentId}
        />
      </Box>

      <AgentSidebar 
        isOpen={isSidebarOpen}
        onToggle={onSidebarToggle}
        onNewAgent={handleNewAgent}
        activeAgentsCount={agents.filter(a => a.status === 'active').length}
      />
    </Flex>
  )
} 